/**
 * enum의 키값은 서버에러 키값과 동일하게 맞추고 있습니다.
 * https://github.daumkakao.com/zzng/zzng-contract/blob/stages/sandbox/pc-api/src/main/kotlin/com/kakao/zzng/contract/pcapi/controller/PcStatus.kt
 */
import { CommonErrorStatus } from '@/constants/error/commonErrorStatus';

export enum ServerAuthErrorStatus {
  // 401 인증
  UNAUTHORIZED = -4010100, // 카카오 로그인이 안되어 있음

  // 403 인증/권한
  NOT_CRUX_USER = -4030101, // 카카오 로그인은 되어 있고 파트너센터 초대도 받았지만, 카포비에 가입되어 있지 않음
  NOT_PC_USER = -4030102, // 카카오 로그인은 되어 있고 파트너센터 초대도 받았고 카포비 가입도 되어 있지만, 파트너센터에 가입되어 있지 않음
  UNAUTHORIZED_AUTH_INFO_ID = -4030110, // 유효하지 않은 인가 ID 이거나 유저가 인가 ID 에 대한 권한이 없음
  FORBIDDEN_API_ACCESS = -4030104, // 해당 API 사용권한이 없음

  NOT_FOUNT_USER = -4040200 // 카카오 로그인은 되어있지만 파트너센터 초대도 안 받았고 카포비 가입도 안 되어 있는 유저
}

export enum ServerPageErrorStatus {
  // 403 인증/권한
  FORBIDDEN = -4030100, // 카카오 로그인은 되어있고 카포비도 가입했으나, 파트너센터에 초대받지 않은 유저

  // FE에서 정의한 에러
  UNDEFINED = 500 // 서버에서 알 수 없는 에러가 발생했을 때 사용
}

// 확인 버튼을 눌렀을 때 팝업이 닫히는 것 외 다른 액션이 필요한 에러들
export enum ServerActionPopupErrorStatus {
  DUPLICATED_SVC_NAME_BUT_REGISTERABLE = -4000603, // 이 사업자번호에 이미 동일한 기관명이 존재합니다. 이 기관명을 사용하시겠습니까?
  NOT_FOUND_COMPANY = -4040300, // 사업자를 찾을 수 없습니다.
  KAPI_FORBIDDEN = -4031000, // 앱 권한이 없습니다.
  INVALID_SETTLE_MAIL = -4000700, // 연동 담당자의 이메일이 유효하지 않아 메일전송에 실패했습니다.
  KAPI_CREATE_BIZAPP = -5001005, // 비즈앱 전환을 할 수 없습니다.
  NOT_FULL_INFO_COMPANY = -4000300 // 사업자 정보가 부족합니다.
}

export enum ServerPopupErrorStatus {
  // 400 인증/유저
  LAST_DEALER_PERMISSION_USER = -4000201, // 딜러사의 마지막 권한 사용자
  LAST_PARTNER_PERMISSION_USER = -4000202, // 이용기관의 마지막 권한 사용자
  DORMANT_USER = -4000203, // 휴면 계정입니다. 휴면 해제후 다시 시도해주세요.
  INVALID_STATUS_USER = -4000204, // 사용할 수 없는 계정입니다. 휴면 해제후 다시 시도해주세요.
  MODIFY_OWN_PERMISSION = -4000205, // 자신의 권한은 수정할 수 없습니다.
  LAST_PERMISSION_USER = -4000206, // 마지막 권한 사용자는 탈퇴할 수 없습니다.
  CAN_NOT_CANCEL_INVITATION_REGISTERED_USER = -4000207, // 이미 초대완료된 멤버입니다.
  LAST_PARTNER_PERMISSION_USER_WITHDRAW = -4000210, // 유효한 이용기관의 마지막 권한 사용자는 탈퇴할 수 없습니다.

  // 400 SVC
  BAD_REQUEST = -4000000, // 잘못된 요청입니다.
  BAD_PARAMETER = -4000001, // 잘못된 파라미터로 요청하였습니다.
  BIZ_TYPE_NOT_MATCHED = -4000002, // 비즈타입이 맞지 않습니다.
  INVALID_INVITE_MAIL = -4000500, // 관리자 메일 발송 실패. 입력한 메일이 수신 가능한 상태인지 확인해 주세요. (저장 용량, 수신 거부, 휴면 상태 등 확인)
  ONLY_HAS_ONE_SVC = -4000600, // 오직 하나의 기관이 있을때만 가능합니다.
  INCOMPLETE_SVC = -4000601, // 필수 정보가 없습니다.
  NOT_VALID_CHANNEL = -4000602, // 올바른 채널이 아닙니다.
  SVC_NAME_NOT_USABLE = -4000604, // 해당 이름을 사용할 수 없습니다.
  BAD_ALIM_TALK_PARAMETER = -4000605, // alimtalk 파라미터가 잘못되었습니다.
  BAD_CS_CENTER_PARAMETER = -4000606, // cs center 파라미터가 잘못되었습니다.
  FAIL_TO_SET_ALIM_TALK = -4000607, // 알림톡 설정에 실패하였습니다.
  NOT_PUBLIC_IPS = -4000608, // 공인IP가 아닙니다.
  NOT_VALID_EMAIL = -4000609, // 올바른 형식의 Email이 아닙니다.
  NOT_VALID_PHONE_NUMBER = -4000610, // 올바른 형식의 Phone number가 아닙니다.
  MISMATCHED_CI_PERMISSION_CHANGE_WITH_SETTLES = -4000613, // CI를 활용하는 Settle 이 존재하여 기관의 CI활용여부를 활용안함으로 변경할 수 없습니다
  CAN_NOT_DELETE_SVC_PARTNER_HAS_ONE_SVC = -4000615, // 이용기관에 등록된 유일한 기관은 삭제할 수 없습니다.
  CAN_NOT_DELETE_SVC_ALREADY_REGISTERED_SETTLE = -4000616, // 등록된 Settle Id가 있어 기관 정보를 삭제할 수 없습니다.

  // 400 settle
  FAILED_SETTLE_MAIL = -4000701, // 암복호화키조회에 실패하여 메일전송에 실패했습니다.
  FAILED_SETTLE_DELETE = -4000702, // 등록된 계약이 있어 settle 정보를 삭제할 수 없습니다.

  // 400 계약
  INVALID_CONTRACT_APPLIED_AT = -4000800, // 계약기간이 잘못 설정되었습니다.
  VALID_DEALER_CONTRACT_NOT_FOUND = -4000801, // 유효한 딜러 계약을 찾을 수 없습니다.
  DUPLICATED_CONTRACT_APPLIED_AT = -4000802, // 같은 기간내에 겹치는 계약이 존재합니다
  NOT_MODIFY_READY_CONTRACT = -4000803, // 대기중인 계약의 상태는 변경할 수 없습니다.
  ONLY_MODIFY_READY_CONTRACT = -4000804, // 이용대기중인 계약에서만 수정 가능한 필드입니다.
  NOT_MODIFY_FINISH_CONTRACT = -4000805, // 만료된 계약은 수정할 수 없습니다.
  INVALID_CONTRACT = -4000806, // 계약의 상태가 비정상입니다.
  INVALID_CHARGING_PERIOD_CONTRACT = -4000807, // 계약 기간에 알맞은 과금기간이 아닙니다.
  AUTO_RENEWAL_ALREADY_EXIST = -4000808, // 자동연장으로 등록된 계약이 존재합니다.

  // 400 앱
  ALREADY_HAS_APP = -4001000, // 이미 앱이 설정되어 있습니다.

  // 400 심사
  ONLY_HAS_ONE_REVIEW = -4001200, // 오직 하나의 리뷰가 있을때만 가능합니다.

  // 400 파일
  SVC_LOGO_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.SVC_LOGO_NOT_ALLOWED_FILE_FORMAT, // 이용기관 로고 & CI문서 > 허용되지 않는 로고 포맷 입니다.
  SVC_LOGO_EXCEEDED_FILE_SIZE = CommonErrorStatus.SVC_LOGO_EXCEEDED_FILE_SIZE, // 이용기관 로고 > 허용되지 않는 로고 파일 용량 입니다.
  SVC_LOGO_NOT_ALLOWED_IMAGE_SIZE = -4001301, // 이용기관 로고 > 허용되지 않는 로고 사이즈 입니다.
  CI_DOC_EXCEEDED_FILE_COUNT = CommonErrorStatus.CI_DOC_EXCEEDED_FILE_COUNT, // CI문서 > 허용되지 않는 ci 문서 파일 갯수 입니다.
  CI_DOC_EXCEEDED_FILE_SIZE = CommonErrorStatus.CI_DOC_EXCEEDED_FILE_SIZE, // CI문서 > 허용되지 않는 ci 문서 용량 입니다.
  CI_DOC_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.CI_DOC_NOT_ALLOWED_FILE_FORMAT, // 허용되지 않는 ci 문서 포맷 입니다.
  CI_DOC_FILE_REQUIRED = CommonErrorStatus.CI_DOC_FILE_REQUIRED, // ci docs 파일이 필요합니다.
  APP_ICON_EXCEEDED_FILE_SIZE = CommonErrorStatus.APP_ICON_EXCEEDED_FILE_SIZE, // 앱 아이콘 > 허용되지 않는 앱아이콘 용량 입니다.
  APP_ICON_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.APP_ICON_NOT_ALLOWED_FILE_FORMAT, // 앱 아이폰 > 허용되지 않는 앱아이콘 포맷 입니다.
  ALIM_TALK_IMAGE_EXCEEDED_FILE_SIZE = CommonErrorStatus.ALIM_TALK_IMAGE_EXCEEDED_FILE_SIZE, // 허용되지 않는 알림톡 이미지 파일 용량 입니다.
  ALIM_TALK_IMAGE_NOT_ALLOWED_IMAGE_SIZE = -4001310, // 허용되지 않는 알림톡 이미지 사이즈 입니다.
  ALIM_TALK_IMAGE_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.ALIM_TALK_IMAGE_NOT_ALLOWED_FILE_FORMAT, // 허용되지 않는 알림톡 이미지 포맷 입니다.
  SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_COUNT = CommonErrorStatus.SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_COUNT, // 정산내역 조정요청 > 허용되지 않는 조정 요청자료 파일 갯수 입니다.
  SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_SIZE = CommonErrorStatus.SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_SIZE, // 정산내역 조정요청 > 허용되지 않는 조정 요청자료 용량 입니다.
  SETTLE_ADJUST_REQUEST_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.SETTLE_ADJUST_REQUEST_NOT_ALLOWED_FILE_FORMAT, // 정산내역 조정요청 > 허용되지 않는 조정 요청자료 포맷 입니다.

  // 400 정산 기본 정보
  NOT_ELIGIBLE_FOR_SETTLEMENT = -4001500, // 정산대상이 아닙니다.
  NO_AVAILABLE_OPERATING_SETTLE = -4001501, // 등록된 발행정보가 없습니다. 발행 정보는 운영용 SettleId와 함께 등록됩니다.

  // 403 앱
  NOT_ENOUGH_PERMISSION = -4030103, // 해당 작업을 실행하기엔 권한이 부족함

  // 404
  NOT_FOUNT_USER_BY_EMAIL = -4040201, // 이메일에 해당하는 유저를 찾을 수 없습니다.
  NOT_FOUND_DEALER = -4040400, // 딜러를 찾을 수 없습니다.
  NOT_FOUND_PARTNER = -4040500, // 이용기관을 찾을 수 없습니다.
  NOT_FOUND_SVC = -4040600, // 기관을 찾을 수 없습니다.
  NOT_FOUND_SETTLE = -4040700, // Settle을 찾을 수 없습니다.
  NOT_FOUND_CONTRACT = -4040800, // 계약을 찾을 수 없습니다.
  NOT_FOUND_PRODUCT = -4040900, // 상품을 찾을 수 없습니다.
  METHOD_NOT_ALLOWED = -4050000, // 허용되지 않은 HTTP 메소드입니다.

  // 409 유저
  USER_ALREADY_INVITED = -4090200, // 이미 초대중인 유저입니다.
  USER_ALREADY_EXIST = -4090201, // 이미 초대완료된 멤버입니다.
  USER_ALREADY_EXIST_WITH_DIFFERENT_EMAIL = -4090202, // 이 카카오계정의 다른 이메일로 가입이 완료되어 초대가 불가합니다. 다른 카카오계정으로 초대해 주세요.

  // 500 공통
  SERVER_ERROR = -5000000, // 일시적인 문제가 발생했습니다.
  FAIL_FILE_UPLOAD = -5000001, // 파일업로드를 실패했습니다.
  FAIL_EXPIRE_HANDLING = -5000002, // 만료시간 설정에 실패했습니다.
  ERROR_TENTH_API = -5000003, // 파일 정보 접근에 실패 하였습니다.
  KAPI_GET_APP = -5001000, // 앱정보를 가져올 수 없습니다.
  KAPI_GET_APP_LIST = -5001001, // 앱목록을 가져올 수 없습니다.
  KAPI_GET_DEVELOPER = -5001002, // 개발자 정보를 가져올 수 없습니다.
  KAPI_USING_KAKAO_LOGIN = -5001003, // 카카오로그인 사용 여부를 가져올 수 없습니다.
  KAPI_IS_BIZAPP = -5001004, // 비즈앱 여부를 알 수 없습니다.
  KAPI_CREATE_OWNERAPP = -5001006, // 앱생성을 할 수 없습니다.
  KAPI_GET_REST_KEY = -5001007, // 앱키를 가져올 수 없습니다.
  INCOMPLETE_APP_INFO = -5001008, // 앱정보가 부족한 앱이 존재합니다.
  KAPI_EXCEEDED_APP_COUNT = -5001010 // 앱생성 갯수를 초과하였습니다.
}
